import { AxiosResponse } from 'axios';
import ApiUrls from '../config/ApiUrls';
import { AppHost } from '../config/Config';
import { replaceByObject } from '../utils/Urls';
import API from './Api';
import { GroupApiResponse } from './GroupApi';

export enum ConnectionProvider {
  xero = 'xero',
  qbo = 'qbo',
}

export function getConnectionProviderName(
  provider: ConnectionProvider
): string {
  const providerNames: { [key in ConnectionProvider]: string } = {
    [ConnectionProvider.xero]: 'Xero',
    [ConnectionProvider.qbo]: 'QuickBooks',
  };
  return providerNames[provider];
}

export class ConnectApi extends API {
  static start(
    groupId: number,
    connectionType: ConnectionProvider
  ): Promise<string> {
    switch (connectionType) {
      case ConnectionProvider.xero:
        return API.post(
          replaceByObject(ApiUrls.ConnectStartXero, { groupId }),
          {},
          {
            params: {
              callback: `${AppHost}/groups/connect`,
            },
          }
        ).then((response: AxiosResponse<string>) => response.data);
      case ConnectionProvider.qbo:
        return API.post(
          replaceByObject(ApiUrls.ConnectStartQBO, { groupId }),
          {},
          {
            params: {
              callback: `${AppHost}/groups/connect/qbo`,
            },
          }
        ).then((response: AxiosResponse<string>) => response.data);
    }
  }

  static complete(
    params: object,
    connectionType: ConnectionProvider = ConnectionProvider.xero
  ): Promise<GroupApiResponse> {
    switch (connectionType) {
      case ConnectionProvider.xero:
        return API.put(ApiUrls.ConnectEndXero, params).then(
          (response: AxiosResponse<GroupApiResponse>) => response.data
        );
      case ConnectionProvider.qbo:
        return API.put(ApiUrls.ConnectEndQBO, params).then(
          (response: AxiosResponse<GroupApiResponse>) => response.data
        );
    }
  }
}
